import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

const resources = {
  'pt-BR': {
    translation: {
      brandTitle: 'Assistente Giveful de Grupos',
      signInSubtitle: 'Entre com o seu codigo de lider para reportar presenca.',
      leadCodeLabel: 'Codigo de Lider',
      leadCodePlaceholder: 'Digite o codigo de lider',
      authLoading: 'Autenticando...',
      continue: 'Entrar',
      authFailed: 'Falha na autenticacao. Verifique seu codigo de lider.',
      authInvalidResponse: 'Resposta de autenticacao invalida do servidor.',
      authRetry: 'Nao foi possivel autenticar. Tente novamente.',
      groupSelectionTitle: 'Para qual grupo voce vai reportar hoje?',
      groupSelectionSubtitle: 'Selecione um grupo para continuar.',
      groupLabel: 'Grupo',
      changeLeadCode: 'Alterar codigo de lider',
      groupChatFallback: 'Chat do Grupo',
      unknownLead: 'Desconhecido',
      leadPrefix: 'Lider',
      liveStatus: 'Ao vivo',
      liveStatusTitle: 'Atualizacoes em tempo real ativas',
      switchGroup: 'Trocar Grupo',
      clearChat: 'Limpar',
      logout: 'Sair',
      switchGroupTitle: 'Trocar grupo',
      clearChatTitle: 'Iniciar novo chat',
      logoutTitle: 'Sair',
      thinking: 'Pensando...',
      chatPlaceholder: 'Digite atualizacoes de presenca, pedidos de oracao ou acompanhamentos...',
      send: 'Enviar',
      sessionExpired: 'Sua sessao expirou. Faca login novamente.',
      genericServerError: 'Erro do servidor: {{status}}',
      updateReceived: 'Atualizacao recebida.',
      sendMessageError: 'Falha ao enviar mensagem. Tente novamente.',
      chatErrorPrefix: 'Erro: {{message}}',
      welcomeMessage: 'Bem-vindo{{nameSuffix}}. Hoje voce esta reportando para **{{groupName}}**.\n\nEnvie atualizacoes de presenca em linguagem natural e eu vou organizar tudo para voce.',
      forgotCodeLink: "Esqueceu seu código?",
      forgotCodeTitle: "Recuperar Código de Líder",
      forgotCodeSubtitle: "Insira seu email para receber o código.",
      emailLabel: "E-mail",
      emailPlaceholder: "seu@email.com",
      sendCode: "Enviar Código",
      cancel: "Cancelar",
      sendingCode: "Enviando...",
      codeSent: "Código enviado para o seu email!",
      invalidEmail: "E-mail inválido.",
      forgotCodeError: "Erro ao enviar o código.",
      languageLabel: 'Idioma',
      languages: {
        'pt-BR': 'Portugues (Brasil)',
        'pt-PT': 'Portugues (Portugal)',
        en: 'English',
        es: 'Espanol',
      },
      // dashboard
      backToCeremonies: 'Voltar para Cerimônias',
      refresh: 'Atualizar',
      participantsCount: '{{count}} participantes',
      tabAttendanceLabel: 'Registrar Presença',
      tabMembersLabel: 'Membros',
      tabStatsLabel: 'Estatísticas',
      tabGamesLabel: 'Jogos',
      // group selection
      selectActiveGroup: 'Selecionar Grupo Ativo',
      reportingForToday: 'Escolha para qual grupo vai reportar presença hoje.',
      // attendance form
      meetingDate: 'Data da Reunião',
      generalAnnotation: 'Anotação Geral',
      generalNotesPlaceholder: 'Notas gerais para esta reunião',
      meetingLocation: 'Local da Reunião',
      physical: 'Presencial',
      online: 'Online',
      addressOptional: 'Endereço (opcional)',
      addressPlaceholder: 'Rua, bairro, cidade',
      geolocationNotSupported: 'Geolocalização não suportada neste navegador.',
      gettingGps: 'Obtendo GPS...',
      useMyGps: 'Usar meu GPS',
      couldNotGetLocation: 'Não foi possível obter localização.',
      meetingUrlOptional: 'URL da Reunião (opcional)',
      participantsLabel: 'Participantes',
      loading: 'Carregando...',
      noParticipantsFound: 'Nenhum participante encontrado para este grupo.',
      noPhone: 'Sem telefone',
      hide: 'Ocultar',
      notes: 'Notas',
      participationScore: 'Pontuação de Participação (1-5)',
      annotationPlaceholder: 'Anotação para este participante',
      submitting: 'Enviando...',
      submitAttendance: 'Finalizar Presença',
      // members tab
      membersTitle: 'Membros',
      registeredCount: 'cadastrado(s)',
      noParticipants: 'Nenhum participante encontrado.',
      // stats tab
      groupStatsTitle: 'Estatísticas do Grupo',
      statsPlaceholder: 'Dados de presença com filtro por semana, mês ou período personalizado.',
      rangeLabel: 'Período',
      weekly: 'Semanal',
      monthly: 'Mensal',
      custom: 'Personalizado',
      fromLabel: 'De',
      toLabel: 'Até',
      statsTotal: 'Total',
      statsPresent: 'Presente',
      statsAbsent: 'Ausente',
      statsLate: 'Atrasado',
      savedReports: 'Relatórios Salvos',
      noAttendanceRecords: 'Nenhum registro de presença para este período.',
      noGeneralNotes: 'Sem notas gerais',
      attendanceEntries: 'registros de presença',
      // event selection
      selectCeremony: 'Selecionar Cerimônia',
      newCeremony: 'Nova Cerimônia',
      ceremonyTitle: 'Título da Cerimônia',
      ceremonyAutoTitlePrefix: 'Reunião',
      ceremonyTitlePlaceholder: 'ex: Reunião Semanal',
      dateLabel: 'Data',
      locationLabel: 'Local',
      saving: 'Salvando...',
      create: 'Criar',
      startNewCeremony: 'Iniciar Nova Cerimônia',
      noCeremoniesFound: 'Nenhuma cerimônia encontrada.',
      startNewCeremonyHint: 'Inicie uma nova para registrar presença.',
      loadingMore: 'Carregando mais cerimônias...',
      // stats mini cards
      statsCardMembers: 'Membros',
      statsCardCeremonies: 'Cerimônias',
      statsCardCurrentList: 'na lista atual',
      statsCardPresence: 'Presença',
      statsCardStats: 'Estatísticas',
      statsCardFinance: 'Financeiro',
      openPanel: 'Abrir painel',
      openFinance: 'Abrir financeiro',
      pendingAttendanceAlert: '{{count}} reunião(ões) sem presença informada pelo líder.',
      pendingAttendanceShort: 'Presença pendente',
      financeScreenEyebrow: 'Financeiro do Grupo',
      financeSummaryCheckouts: 'Campanhas',
      financeSummaryRaised: 'Arrecadado',
      financeSummaryStatus: 'Status',
      financeComingSoonTitle: 'Módulo financeiro ativado',
      financeComingSoonBody: 'Este grupo já está habilitado para o Financeiro. O próximo passo é ligar a listagem de checkouts, filtros e analytics do backend nesta tela.',
      financeScheduledLabel: 'Programado',
      financeInactiveLabel: 'Encerrado',
      financeActiveLabel: 'Ativo',
      financeSummaryCheckoutsDetail: '{{active}} ativos / {{inactive}} encerrados',
      financeSummaryRaisedDetail: 'Somatório confirmado do grupo',
      financeNoSelectionShort: 'Sem seleção',
      financeSummaryStatusDetail: 'Campanha atual: {{title}}',
      financeSummaryStatusIdle: 'Selecione uma campanha para ver o saldo.',
      financeModuleTitle: 'Campanhas do grupo',
      financeModuleSubtitle: 'Pesquise, filtre e acompanhe pagamentos e saldo de cada campanha.',
      financeCreateCheckout: 'Nova campanha',
      financeCreateTitlePlaceholder: 'Ex: Oferta do mês, Retiro, Ação solidária',
      financeCreateDescriptionPlaceholder: 'Explique o objetivo da arrecadação.',
      financeAmountLabel: 'Valor sugerido',
      financeFreeValueLabel: 'Doação de valor livre',
      financeNoOption: 'Não',
      financeYesOption: 'Sim',
      financeStartsOnLabel: 'Início',
      financeEndsOnLabel: 'Fim',
      financeAnonymousLabel: 'Permitir pagamentos sem login',
      financeSearchPlaceholder: 'Buscar campanha...',
      financeSearchButton: 'Buscar campanha',
      financeListTitle: 'Campanhas',
      financeEmptyState: 'Nenhuma campanha encontrada com os filtros atuais.',
      financeNoDescription: 'Sem descrição.',
      financeLoadingDetail: 'Carregando campanha...',
      financeNoSelection: 'Selecione uma campanha para ver pagamentos, saldo e detalhes.',
      financeTargetAmount: 'Valor base',
      financePaymentMethods: 'Métodos',
      financeCheckoutLink: 'Link público da campanha',
      financeShareCampaign: 'Partilhar campanha',
      financeShareSuccess: 'Link da campanha pronto para partilha.',
      financeCopySuccess: 'Link da campanha copiado.',
      financeShareError: 'Não foi possível partilhar a campanha.',
      financeRecentPayments: 'Pagamentos recentes',
      financePaymentStatus: 'Status',
      financeProviderLabel: 'Canal',
      financeNoPayments: 'Ainda não existem pagamentos nesta campanha.',
      financeBalanceTitle: 'Resumo financeiro',
      financeRaisedTotal: 'Total bruto',
      financeAvailableTotal: 'Disponível',
      financePendingTotal: 'Pendente',
      financePaymentsCount: 'Pagamentos',
      financeStatusBreakdown: 'Por status',
      financeNoStatusData: 'Sem pagamentos suficientes para distribuir por status.',
      financeProvidersBreakdown: 'Por canal',
      financeNoProviderData: 'Sem pagamentos suficientes para distribuir por canal.',
      financeTopCampaignsTitle: 'Campanhas com melhor resultado',
      financeUntitledCampaign: 'Campanha sem título',
      financeCampaignPaymentsCount: '{{count}} pagamentos confirmados',
      financeNoCampaigns: 'Quando houver pagamentos confirmados, os checkouts com maior arrecadação aparecem aqui.',
      financeLoadMoreCheckouts: 'Carregar mais campanhas',
      financeLoadMorePayments: 'Carregar mais pagamentos',
      // search/filter
      searchCeremony: 'Buscar cerimônia...',
      filterStatus: 'Filtrar por status',
      allStatuses: 'Todos os status',
      statusScheduled: 'Agendada',
      statusCompleted: 'Concluída',
      statusCancelled: 'Cancelada',
      // members panel
      membersPanelTitle: 'Membros e Estatísticas',
      noRealtime: 'Sem realtime. Atualize manualmente quando quiser recalcular.',
      closeMembersPanel: 'Fechar painel de membros',
      membersPanelDescription: 'Lista de membros, ranking de presença e histórico individual.',
      attendanceRateLabel: 'Presença',
      groupMembers: 'Membros do grupo',
      noEnoughAttendance: 'Os indicadores aparecem assim que houver presença suficiente registrada.',
      noMembersFound: 'Nenhum membro encontrado para este grupo.',
      noPhoneRegistered: 'Sem telefone cadastrado',
      loadingMemberDetails: 'Carregando detalhes do membro...',
      selectedMember: 'Membro selecionado',
      rateLabel: 'Taxa',
      consistencyLabel: 'Consistência',
      presentLabel: 'Presentes',
      absencesLabel: 'Ausências',
      recentCeremonies: 'Últimas cerimônias',
      selectMemberForDetails: 'Selecione um membro para ver detalhes e tendências individuais.',
    },
  },
  'pt-PT': {
    translation: {
      brandTitle: 'Assistente Giveful de Grupos',
      signInSubtitle: 'Inicie sessao com o seu codigo de lider para reportar presencas.',
      leadCodeLabel: 'Codigo de Lider',
      leadCodePlaceholder: 'Introduza o codigo de lider',
      authLoading: 'A autenticar...',
      continue: 'Prosseguir',
      authFailed: 'Falha na autenticacao. Verifique o seu codigo de lider.',
      authInvalidResponse: 'Resposta de autenticacao invalida do servidor.',
      authRetry: 'Nao foi possivel autenticar. Tente novamente.',
      groupSelectionTitle: 'Para que grupo esta a reportar hoje?',
      groupSelectionSubtitle: 'Selecione um grupo para continuar.',
      groupLabel: 'Grupo',
      changeLeadCode: 'Alterar codigo de lider',
      groupChatFallback: 'Conversa do Grupo',
      unknownLead: 'Desconhecido',
      leadPrefix: 'Lider',
      liveStatus: 'Em direto',
      liveStatusTitle: 'Atualizacoes em tempo real ativas',
      switchGroup: 'Mudar Grupo',
      clearChat: 'Limpar',
      logout: 'Terminar sessao',
      switchGroupTitle: 'Mudar grupo',
      clearChatTitle: 'Iniciar nova conversa',
      logoutTitle: 'Terminar sessao',
      thinking: 'A pensar...',
      chatPlaceholder: 'Escreva atualizacoes de presencas, pedidos de oracao ou seguimentos...',
      send: 'Enviar',
      sessionExpired: 'A sessao expirou. Inicie sessao novamente.',
      genericServerError: 'Erro do servidor: {{status}}',
      updateReceived: 'Atualizacao recebida.',
      sendMessageError: 'Nao foi possivel enviar a mensagem. Tente novamente.',
      chatErrorPrefix: 'Erro: {{message}}',
      welcomeMessage: 'Bem-vindo{{nameSuffix}}. Hoje esta a reportar para **{{groupName}}**.\n\nEnvie atualizacoes de presenca em linguagem natural e eu organizo tudo por si.',
      forgotCodeLink: "Esqueceu-se do seu código?",
      forgotCodeTitle: "Recuperar Código de Líder",
      forgotCodeSubtitle: "Introduza o seu email para receber o código.",
      emailLabel: "E-mail",
      emailPlaceholder: "seu@email.com",
      sendCode: "Enviar Código",
      cancel: "Cancelar",
      sendingCode: "A enviar...",
      codeSent: "Código enviado para o seu email!",
      invalidEmail: "E-mail inválido.",
      forgotCodeError: "Erro ao enviar o código.",
      languageLabel: 'Idioma',
      languages: {
        'pt-BR': 'Portugues (Brasil)',
        'pt-PT': 'Portugues (Portugal)',
        en: 'English',
        es: 'Espanol',
      },
      // dashboard
      backToCeremonies: 'Voltar para Cerimónias',
      refresh: 'Atualizar',
      participantsCount: '{{count}} participantes',
      tabAttendanceLabel: 'Registar Presença',
      tabMembersLabel: 'Membros',
      tabStatsLabel: 'Estatísticas',
      tabGamesLabel: 'Jogos',
      // group selection
      selectActiveGroup: 'Selecionar Grupo Ativo',
      reportingForToday: 'Escolha para que grupo vai reportar presenças hoje.',
      // attendance form
      meetingDate: 'Data da Reunião',
      generalAnnotation: 'Anotação Geral',
      generalNotesPlaceholder: 'Notas gerais para esta reunião',
      meetingLocation: 'Local da Reunião',
      physical: 'Presencial',
      online: 'Online',
      addressOptional: 'Morada (opcional)',
      addressPlaceholder: 'Rua, bairro, cidade',
      geolocationNotSupported: 'Geolocalização não suportada neste navegador.',
      gettingGps: 'A obter GPS...',
      useMyGps: 'Usar o meu GPS',
      couldNotGetLocation: 'Não foi possível obter localização.',
      meetingUrlOptional: 'URL da Reunião (opcional)',
      participantsLabel: 'Participantes',
      loading: 'A carregar...',
      noParticipantsFound: 'Nenhum participante encontrado para este grupo.',
      noPhone: 'Sem telefone',
      hide: 'Ocultar',
      notes: 'Notas',
      membersTitle: 'Membros',
      registeredCount: 'registado(s)',
      noParticipants: 'Nenhum participante encontrado.',
      // stats tab
      groupStatsTitle: 'Estatísticas do Grupo',
      statsPlaceholder: 'Dados de presença com filtro por semana, mês ou período personalizado.',
      rangeLabel: 'Período',
      weekly: 'Semanal',
      monthly: 'Mensal',
      custom: 'Personalizado',
      fromLabel: 'De',
      toLabel: 'Até',
      statsTotal: 'Total',
      statsPresent: 'Presente',
      statsAbsent: 'Ausente',
      statsLate: 'Atrasado',
      savedReports: 'Relatórios Guardados',
      noAttendanceRecords: 'Nenhum registo de presença para este período.',
      noGeneralNotes: 'Sem notas gerais',
      attendanceEntries: 'registos de presença',
      // event selection
      selectCeremony: 'Selecionar Cerimónia',
      newCeremony: 'Nova Cerimónia',
      ceremonyTitle: 'Título da Cerimónia',
      ceremonyAutoTitlePrefix: 'Reunião',
      ceremonyTitlePlaceholder: 'ex: Reunião Semanal',
      dateLabel: 'Data',
      locationLabel: 'Local',
      saving: 'A guardar...',
      create: 'Criar',
      startNewCeremony: 'Iniciar Nova Cerimónia',
      noCeremoniesFound: 'Nenhuma cerimónia encontrada.',
      startNewCeremonyHint: 'Inicie uma nova para registar presença.',
      loadingMore: 'A carregar mais cerimónias...',
      // stats mini cards
      statsCardMembers: 'Membros',
      statsCardCeremonies: 'Cerimónias',
      statsCardCurrentList: 'na lista atual',
      statsCardPresence: 'Presença',
      statsCardStats: 'Estatísticas',
      statsCardFinance: 'Financeiro',
      openPanel: 'Abrir painel',
      openFinance: 'Abrir financeiro',
      pendingAttendanceAlert: '{{count}} reunião(ões) sem presença registada pelo líder.',
      pendingAttendanceShort: 'Presença pendente',
      financeScreenEyebrow: 'Financeiro do Grupo',
      financeSummaryCheckouts: 'Campanhas',
      financeSummaryRaised: 'Arrecadado',
      financeSummaryStatus: 'Estado',
      financeComingSoonTitle: 'Módulo financeiro ativado',
      financeComingSoonBody: 'Este grupo já está habilitado para o Financeiro. O próximo passo é ligar a listagem de checkouts, filtros e analytics do backend neste ecrã.',
      financeScheduledLabel: 'Agendado',
      financeInactiveLabel: 'Encerrado',
      financeActiveLabel: 'Ativo',
      financeSummaryCheckoutsDetail: '{{active}} ativos / {{inactive}} encerrados',
      financeSummaryRaisedDetail: 'Somatório confirmado do grupo',
      financeNoSelectionShort: 'Sem seleção',
      financeSummaryStatusDetail: 'Campanha atual: {{title}}',
      financeSummaryStatusIdle: 'Selecione uma campanha para ver o saldo.',
      financeModuleTitle: 'Campanhas do grupo',
      financeModuleSubtitle: 'Pesquise, filtre e acompanhe pagamentos e saldo de cada campanha.',
      financeCreateCheckout: 'Nova campanha',
      financeCreateTitlePlaceholder: 'Ex: Oferta do mês, Retiro, Ação solidária',
      financeCreateDescriptionPlaceholder: 'Explique o objetivo da angariação.',
      financeAmountLabel: 'Valor sugerido',
      financeFreeValueLabel: 'Donativo de valor livre',
      financeNoOption: 'Não',
      financeYesOption: 'Sim',
      financeStartsOnLabel: 'Início',
      financeEndsOnLabel: 'Fim',
      financeAnonymousLabel: 'Permitir pagamentos sem autenticação',
      financeSearchPlaceholder: 'Procurar campanha...',
      financeSearchButton: 'Procurar campanha',
      financeListTitle: 'Campanhas',
      financeEmptyState: 'Nenhuma campanha encontrada com os filtros atuais.',
      financeNoDescription: 'Sem descrição.',
      financeLoadingDetail: 'A carregar campanha...',
      financeNoSelection: 'Selecione uma campanha para ver pagamentos, saldo e detalhes.',
      financeTargetAmount: 'Valor base',
      financePaymentMethods: 'Métodos',
      financeCheckoutLink: 'Ligação pública da campanha',
      financeShareCampaign: 'Partilhar campanha',
      financeShareSuccess: 'Ligação da campanha pronta para partilha.',
      financeCopySuccess: 'Ligação da campanha copiada.',
      financeShareError: 'Não foi possível partilhar a campanha.',
      financeRecentPayments: 'Pagamentos recentes',
      financePaymentStatus: 'Estado',
      financeProviderLabel: 'Canal',
      financeNoPayments: 'Ainda não existem pagamentos nesta campanha.',
      financeBalanceTitle: 'Resumo financeiro',
      financeRaisedTotal: 'Total bruto',
      financeAvailableTotal: 'Disponível',
      financePendingTotal: 'Pendente',
      financePaymentsCount: 'Pagamentos',
      financeStatusBreakdown: 'Por estado',
      financeNoStatusData: 'Sem pagamentos suficientes para distribuir por estado.',
      financeProvidersBreakdown: 'Por canal',
      financeNoProviderData: 'Sem pagamentos suficientes para distribuir por canal.',
      financeTopCampaignsTitle: 'Campanhas com melhor resultado',
      financeUntitledCampaign: 'Campanha sem título',
      financeCampaignPaymentsCount: '{{count}} pagamentos confirmados',
      financeNoCampaigns: 'Quando houver pagamentos confirmados, os checkouts com maior angariação aparecem aqui.',
      financeLoadMoreCheckouts: 'Carregar mais campanhas',
      financeLoadMorePayments: 'Carregar mais pagamentos',
      // search/filter
      searchCeremony: 'Procurar cerimónia...',
      filterStatus: 'Filtrar por estado',
      allStatuses: 'Todos os estados',
      statusScheduled: 'Agendada',
      statusCompleted: 'Concluída',
      statusCancelled: 'Cancelada',
      // members panel
      membersPanelTitle: 'Membros e Estatísticas',
      noRealtime: 'Sem tempo real. Atualize manualmente para recalcular.',
      closeMembersPanel: 'Fechar painel de membros',
      membersPanelDescription: 'Lista de membros, ranking de presença e histórico individual.',
      attendanceRateLabel: 'Presença',
      groupMembers: 'Membros do grupo',
      noEnoughAttendance: 'Os indicadores aparecem assim que houver presença suficiente registada.',
      noMembersFound: 'Nenhum membro encontrado para este grupo.',
      noPhoneRegistered: 'Sem telefone registado',
      loadingMemberDetails: 'A carregar detalhes do membro...',
      selectedMember: 'Membro selecionado',
      rateLabel: 'Taxa',
      consistencyLabel: 'Consistência',
      presentLabel: 'Presentes',
      absencesLabel: 'Ausências',
      recentCeremonies: 'Últimas cerimónias',
      selectMemberForDetails: 'Selecione um membro para ver detalhes e tendências individuais.',
    },
  },
  en: {
    translation: {
      brandTitle: 'Giveful Group Assistant',
      signInSubtitle: 'Sign in with your lead code to report attendance.',
      leadCodeLabel: 'Lead Code',
      leadCodePlaceholder: 'Enter your lead code',
      authLoading: 'Authenticating...',
      continue: 'Continue',
      authFailed: 'Authentication failed. Please check your lead code.',
      authInvalidResponse: 'Invalid authentication response from server.',
      authRetry: 'Could not authenticate. Please try again.',
      groupSelectionTitle: 'Which group are you reporting for today?',
      groupSelectionSubtitle: 'Select one to continue.',
      groupLabel: 'Group',
      changeLeadCode: 'Change lead code',
      groupChatFallback: 'Group Chat',
      unknownLead: 'Unknown',
      leadPrefix: 'Lead',
      liveStatus: 'Live',
      liveStatusTitle: 'Real-time updates active',
      switchGroup: 'Switch Group',
      clearChat: 'Clear',
      logout: 'Logout',
      switchGroupTitle: 'Switch group',
      clearChatTitle: 'Start new chat',
      logoutTitle: 'Logout',
      thinking: 'Thinking...',
      chatPlaceholder: 'Type attendance updates, prayer points, or follow-up notes...',
      send: 'Send',
      sessionExpired: 'Your session expired. Please authenticate again.',
      genericServerError: 'Server error: {{status}}',
      updateReceived: 'Update received.',
      sendMessageError: 'Failed to send message. Please try again.',
      chatErrorPrefix: 'Error: {{message}}',
      welcomeMessage: 'Welcome{{nameSuffix}}. You are reporting for **{{groupName}}** today.\n\nSend attendance updates in plain language, and I will organize them for you.',
      forgotCodeLink: "Forgot your code?",
      forgotCodeTitle: "Recover Lead Code",
      forgotCodeSubtitle: "Enter your email to receive a new code.",
      emailLabel: "Email",
      emailPlaceholder: "your@email.com",
      sendCode: "Send Code",
      cancel: "Cancel",
      sendingCode: "Sending...",
      codeSent: "Code sent to your email!",
      invalidEmail: "Invalid email address.",
      forgotCodeError: "Error sending code.",
      languageLabel: 'Language',
      languages: {
        'pt-BR': 'Portuguese (Brazil)',
        'pt-PT': 'Portuguese (Portugal)',
        en: 'English',
        es: 'Spanish',
      },
      // dashboard
      backToCeremonies: 'Back to Ceremonies',
      refresh: 'Refresh',
      participantsCount: '{{count}} participants',
      tabAttendanceLabel: 'Take Attendance',
      tabMembersLabel: 'Member List',
      tabStatsLabel: 'Group Stats',
      tabGamesLabel: 'Games',
      // group selection
      selectActiveGroup: 'Select Active Group',
      reportingForToday: 'Choose which group you are reporting attendance for today.',
      // attendance form
      meetingDate: 'Meeting Date',
      generalAnnotation: 'General Annotation',
      generalNotesPlaceholder: 'General notes for this meeting',
      meetingLocation: 'Meeting Location',
      physical: 'Physical',
      online: 'Online',
      addressOptional: 'Address (optional)',
      addressPlaceholder: 'Street, neighborhood, city',
      geolocationNotSupported: 'Geolocation is not supported by this browser.',
      gettingGps: 'Getting GPS...',
      useMyGps: 'Use my GPS',
      couldNotGetLocation: 'Could not get current location.',
      meetingUrlOptional: 'Meeting URL (optional)',
      participantsLabel: 'Participants',
      loading: 'Loading...',
      noParticipantsFound: 'No participants found for this group.',
      noPhone: 'No phone number',
      hide: 'Hide',
      notes: 'Notes',
      annotationPlaceholder: 'Annotation for this participant',
      submitting: 'Submitting...',
      submitAttendance: 'Submit Attendance',
      // members tab
      membersTitle: 'Members',
      registeredCount: 'registered',
      noParticipants: 'No participants found.',
      // stats tab
      groupStatsTitle: 'Group Stats',
      statsPlaceholder: 'Attendance analytics with weekly, monthly or custom date filtering.',
      rangeLabel: 'Range',
      weekly: 'Weekly',
      monthly: 'Monthly',
      custom: 'Custom',
      fromLabel: 'From',
      toLabel: 'To',
      statsTotal: 'Total',
      statsPresent: 'Present',
      statsAbsent: 'Absent',
      statsLate: 'Late',
      savedReports: 'Saved Reports',
      noAttendanceRecords: 'No attendance records yet for this interval.',
      noGeneralNotes: 'No general notes',
      attendanceEntries: 'attendance entries',
      // event selection
      selectCeremony: 'Select Ceremony',
      newCeremony: 'New Ceremony',
      ceremonyTitle: 'Ceremony Title',
      ceremonyAutoTitlePrefix: 'Meeting',
      ceremonyTitlePlaceholder: 'e.g. Weekly Meeting',
      dateLabel: 'Date',
      locationLabel: 'Location',
      saving: 'Saving...',
      create: 'Create',
      startNewCeremony: 'Start New Ceremony',
      noCeremoniesFound: 'No ceremonies found.',
      startNewCeremonyHint: 'Start a new one to register attendance.',
      loadingMore: 'Loading more ceremonies...',
      // stats mini cards
      statsCardMembers: 'Members',
      statsCardCeremonies: 'Ceremonies',
      statsCardCurrentList: 'in current list',
      statsCardPresence: 'Attendance',
      statsCardStats: 'Statistics',
      statsCardFinance: 'Finance',
      openPanel: 'Open panel',
      openFinance: 'Open finance',
      pendingAttendanceAlert: '{{count}} meeting(s) still missing attendance from the leader.',
      pendingAttendanceShort: 'Attendance pending',
      financeScreenEyebrow: 'Group Finance',
      financeSummaryCheckouts: 'Campaigns',
      financeSummaryRaised: 'Raised',
      financeSummaryStatus: 'Status',
      financeComingSoonTitle: 'Finance module enabled',
      financeComingSoonBody: 'This group is already enabled for Finance. The next step is wiring the checkout list, filters, and backend analytics into this screen.',
      financeScheduledLabel: 'Scheduled',
      financeInactiveLabel: 'Closed',
      financeActiveLabel: 'Active',
      financeSummaryCheckoutsDetail: '{{active}} active / {{inactive}} closed',
      financeSummaryRaisedDetail: 'Confirmed total raised by this group',
      financeNoSelectionShort: 'No selection',
      financeSummaryStatusDetail: 'Current campaign: {{title}}',
      financeSummaryStatusIdle: 'Select a campaign to inspect its balance.',
      financeModuleTitle: 'Group campaigns',
      financeModuleSubtitle: 'Search, filter, and track payments and balances for each campaign.',
      financeCreateCheckout: 'New campaign',
      financeCreateTitlePlaceholder: 'Ex: Monthly offering, Retreat, Solidarity drive',
      financeCreateDescriptionPlaceholder: 'Explain the goal of this fundraiser.',
      financeAmountLabel: 'Suggested amount',
      financeFreeValueLabel: 'Open amount donation',
      financeNoOption: 'No',
      financeYesOption: 'Yes',
      financeStartsOnLabel: 'Starts on',
      financeEndsOnLabel: 'Ends on',
      financeAnonymousLabel: 'Allow payments without sign-in',
      financeSearchPlaceholder: 'Search campaign...',
      financeSearchButton: 'Search campaign',
      financeListTitle: 'Campaigns',
      financeEmptyState: 'No campaigns matched the current filters.',
      financeNoDescription: 'No description.',
      financeLoadingDetail: 'Loading campaign...',
      financeNoSelection: 'Select a campaign to inspect payments, balance, and details.',
      financeTargetAmount: 'Base amount',
      financePaymentMethods: 'Methods',
      financeCheckoutLink: 'Public campaign link',
      financeShareCampaign: 'Share campaign',
      financeShareSuccess: 'Campaign link ready to share.',
      financeCopySuccess: 'Campaign link copied.',
      financeShareError: 'Unable to share the campaign.',
      financeRecentPayments: 'Recent payments',
      financePaymentStatus: 'Status',
      financeProviderLabel: 'Channel',
      financeNoPayments: 'There are no payments for this campaign yet.',
      financeBalanceTitle: 'Financial summary',
      financeRaisedTotal: 'Gross total',
      financeAvailableTotal: 'Available',
      financePendingTotal: 'Pending',
      financePaymentsCount: 'Payments',
      financeStatusBreakdown: 'By status',
      financeNoStatusData: 'Not enough payments yet to show a status breakdown.',
      financeProvidersBreakdown: 'By channel',
      financeNoProviderData: 'Not enough payments yet to show a channel breakdown.',
      financeTopCampaignsTitle: 'Top performing campaigns',
      financeUntitledCampaign: 'Untitled campaign',
      financeCampaignPaymentsCount: '{{count}} confirmed payments',
      financeNoCampaigns: 'Top-raising campaigns will appear here once confirmed payments start coming in.',
      financeLoadMoreCheckouts: 'Load more campaigns',
      financeLoadMorePayments: 'Load more payments',
      // search/filter
      searchCeremony: 'Search ceremony...',
      filterStatus: 'Filter by status',
      allStatuses: 'All statuses',
      statusScheduled: 'Scheduled',
      statusCompleted: 'Completed',
      statusCancelled: 'Cancelled',
      // members panel
      membersPanelTitle: 'Members & Statistics',
      noRealtime: 'No realtime. Refresh manually to recalculate.',
      closeMembersPanel: 'Close members panel',
      membersPanelDescription: 'Member list, attendance ranking and individual history.',
      attendanceRateLabel: 'Attendance',
      groupMembers: 'Group Members',
      noEnoughAttendance: 'Indicators appear once enough attendance has been recorded.',
      noMembersFound: 'No members found for this group.',
      noPhoneRegistered: 'No phone registered',
      loadingMemberDetails: 'Loading member details...',
      selectedMember: 'Selected Member',
      rateLabel: 'Rate',
      consistencyLabel: 'Consistency',
      presentLabel: 'Present',
      absencesLabel: 'Absences',
      recentCeremonies: 'Recent Ceremonies',
      selectMemberForDetails: 'Select a member to view individual details and trends.',
    },
  },
  es: {
    translation: {
      brandTitle: 'Asistente de Grupos Giveful',
      signInSubtitle: 'Inicia sesion con tu codigo de lider para reportar asistencia.',
      leadCodeLabel: 'Codigo del Lider',
      leadCodePlaceholder: 'Ingresa tu codigo de lider',
      authLoading: 'Autenticando...',
      continue: 'Continuar',
      authFailed: 'Error de autenticacion. Revisa tu codigo de lider.',
      authInvalidResponse: 'Respuesta de autenticacion invalida del servidor.',
      authRetry: 'No fue posible autenticar. Intentalo nuevamente.',
      groupSelectionTitle: 'Para que grupo reportas hoy?',
      groupSelectionSubtitle: 'Selecciona uno para continuar.',
      groupLabel: 'Grupo',
      changeLeadCode: 'Cambiar codigo de lider',
      groupChatFallback: 'Chat del Grupo',
      unknownLead: 'Desconocido',
      leadPrefix: 'Lider',
      liveStatus: 'En vivo',
      liveStatusTitle: 'Actualizaciones en tiempo real activas',
      switchGroup: 'Cambiar Grupo',
      clearChat: 'Limpiar',
      logout: 'Cerrar sesion',
      switchGroupTitle: 'Cambiar grupo',
      clearChatTitle: 'Iniciar nuevo chat',
      logoutTitle: 'Cerrar sesion',
      thinking: 'Pensando...',
      chatPlaceholder: 'Escribe actualizaciones de asistencia, peticiones de oracion o seguimiento...',
      send: 'Enviar',
      sessionExpired: 'Tu sesion expiro. Inicia sesion nuevamente.',
      genericServerError: 'Error del servidor: {{status}}',
      updateReceived: 'Actualizacion recibida.',
      sendMessageError: 'No se pudo enviar el mensaje. Intentalo nuevamente.',
      chatErrorPrefix: 'Error: {{message}}',
      welcomeMessage: 'Bienvenido{{nameSuffix}}. Hoy reportas para **{{groupName}}**.\n\nEnvia actualizaciones de asistencia en lenguaje natural y yo lo organizo por ti.',
      languageLabel: 'Idioma',
      languages: {
        'pt-BR': 'Portugues (Brasil)',
        'pt-PT': 'Portugues (Portugal)',
        en: 'English',
        es: 'Espanol',
      },
      // dashboard
      backToCeremonies: 'Volver a Ceremonias',
      refresh: 'Actualizar',
      participantsCount: '{{count}} participantes',
      tabAttendanceLabel: 'Registrar Asistencia',
      tabMembersLabel: 'Miembros',
      tabStatsLabel: 'Estadísticas',
      tabGamesLabel: 'Juegos',
      // group selection
      selectActiveGroup: 'Seleccionar Grupo Activo',
      reportingForToday: 'Elige para qué grupo reportas asistencia hoy.',
      // attendance form
      meetingDate: 'Fecha de la Reunión',
      generalAnnotation: 'Anotación General',
      generalNotesPlaceholder: 'Notas generales para esta reunión',
      meetingLocation: 'Lugar de la Reunión',
      physical: 'Presencial',
      online: 'Online',
      addressOptional: 'Dirección (opcional)',
      addressPlaceholder: 'Calle, barrio, ciudad',
      geolocationNotSupported: 'La geolocalización no está soportada en este navegador.',
      gettingGps: 'Obteniendo GPS...',
      useMyGps: 'Usar mi GPS',
      couldNotGetLocation: 'No se pudo obtener la ubicación.',
      meetingUrlOptional: 'URL de la Reunión (opcional)',
      participantsLabel: 'Participantes',
      loading: 'Cargando...',
      noParticipantsFound: 'No se encontraron participantes para este grupo.',
      noPhone: 'Sin teléfono',
      hide: 'Ocultar',
      notes: 'Notas',
      annotationPlaceholder: 'Anotación para este participante',
      submitting: 'Enviando...',
      submitAttendance: 'Registrar Asistencia',
      // members tab
      membersTitle: 'Miembros',
      registeredCount: 'registrado(s)',
      noParticipants: 'No se encontraron participantes.',
      // stats tab
      groupStatsTitle: 'Estadísticas del Grupo',
      statsPlaceholder: 'Datos de asistencia con filtro semanal, mensual o personalizado.',
      rangeLabel: 'Período',
      weekly: 'Semanal',
      monthly: 'Mensual',
      custom: 'Personalizado',
      fromLabel: 'Desde',
      toLabel: 'Hasta',
      statsTotal: 'Total',
      statsPresent: 'Presente',
      statsAbsent: 'Ausente',
      statsLate: 'Tardanza',
      savedReports: 'Informes Guardados',
      noAttendanceRecords: 'No hay registros de asistencia para este período.',
      noGeneralNotes: 'Sin notas generales',
      attendanceEntries: 'registros de asistencia',
      // event selection
      selectCeremony: 'Seleccionar Ceremonia',
      newCeremony: 'Nueva Ceremonia',
      ceremonyTitle: 'Título de la Ceremonia',
      ceremonyAutoTitlePrefix: 'Reunión',
      ceremonyTitlePlaceholder: 'ej: Reunión Semanal',
      dateLabel: 'Fecha',
      locationLabel: 'Lugar',
      saving: 'Guardando...',
      create: 'Crear',
      startNewCeremony: 'Iniciar Nueva Ceremonia',
      noCeremoniesFound: 'No se encontraron ceremonias.',
      startNewCeremonyHint: 'Inicia una nueva para registrar asistencia.',
      loadingMore: 'Cargando más ceremonias...',
      // stats mini cards
      statsCardMembers: 'Miembros',
      statsCardCeremonies: 'Ceremonias',
      statsCardCurrentList: 'en la lista actual',
      statsCardPresence: 'Asistencia',
      statsCardStats: 'Estadísticas',
      statsCardFinance: 'Finanzas',
      openPanel: 'Abrir panel',
      openFinance: 'Abrir finanzas',
      pendingAttendanceAlert: '{{count}} reunión(es) aún sin asistencia informada por el líder.',
      pendingAttendanceShort: 'Asistencia pendiente',
      financeScreenEyebrow: 'Finanzas del Grupo',
      financeSummaryCheckouts: 'Campañas',
      financeSummaryRaised: 'Recaudado',
      financeSummaryStatus: 'Estado',
      financeComingSoonTitle: 'Módulo financiero activado',
      financeComingSoonBody: 'Este grupo ya está habilitado para Finanzas. El siguiente paso es conectar en esta pantalla la lista de checkouts, filtros y analytics del backend.',
      financeScheduledLabel: 'Programado',
      financeInactiveLabel: 'Cerrado',
      financeActiveLabel: 'Activo',
      financeSummaryCheckoutsDetail: '{{active}} activos / {{inactive}} cerrados',
      financeSummaryRaisedDetail: 'Total confirmado recaudado por el grupo',
      financeNoSelectionShort: 'Sin selección',
      financeSummaryStatusDetail: 'Campaña actual: {{title}}',
      financeSummaryStatusIdle: 'Selecciona una campaña para revisar su saldo.',
      financeModuleTitle: 'Campañas del grupo',
      financeModuleSubtitle: 'Busca, filtra y sigue pagos y saldo de cada campaña.',
      financeCreateCheckout: 'Nueva campaña',
      financeCreateTitlePlaceholder: 'Ej: Ofrenda del mes, Retiro, Campaña solidaria',
      financeCreateDescriptionPlaceholder: 'Explica el objetivo de esta recaudación.',
      financeAmountLabel: 'Importe sugerido',
      financeFreeValueLabel: 'Donación de valor libre',
      financeNoOption: 'No',
      financeYesOption: 'Sí',
      financeStartsOnLabel: 'Inicio',
      financeEndsOnLabel: 'Fin',
      financeAnonymousLabel: 'Permitir pagos sin iniciar sesión',
      financeSearchPlaceholder: 'Buscar campaña...',
      financeSearchButton: 'Buscar campaña',
      financeListTitle: 'Campañas',
      financeEmptyState: 'Ninguna campaña coincide con los filtros actuales.',
      financeNoDescription: 'Sin descripción.',
      financeLoadingDetail: 'Cargando campaña...',
      financeNoSelection: 'Selecciona una campaña para revisar pagos, saldo y detalles.',
      financeTargetAmount: 'Importe base',
      financePaymentMethods: 'Métodos',
      financeCheckoutLink: 'Enlace público de la campaña',
      financeShareCampaign: 'Compartir campaña',
      financeShareSuccess: 'Enlace de la campaña listo para compartir.',
      financeCopySuccess: 'Enlace de la campaña copiado.',
      financeShareError: 'No se pudo compartir la campaña.',
      financeRecentPayments: 'Pagos recientes',
      financePaymentStatus: 'Estado',
      financeProviderLabel: 'Canal',
      financeNoPayments: 'Todavía no hay pagos en esta campaña.',
      financeBalanceTitle: 'Resumen financiero',
      financeRaisedTotal: 'Total bruto',
      financeAvailableTotal: 'Disponible',
      financePendingTotal: 'Pendiente',
      financePaymentsCount: 'Pagos',
      financeStatusBreakdown: 'Por estado',
      financeNoStatusData: 'Aún no hay suficientes pagos para mostrar el desglose por estado.',
      financeProvidersBreakdown: 'Por canal',
      financeNoProviderData: 'Aún no hay suficientes pagos para mostrar el desglose por canal.',
      financeTopCampaignsTitle: 'Campañas con mejor resultado',
      financeUntitledCampaign: 'Campaña sin título',
      financeCampaignPaymentsCount: '{{count}} pagos confirmados',
      financeNoCampaigns: 'Las campañas con mayor recaudación aparecerán aquí cuando existan pagos confirmados.',
      financeLoadMoreCheckouts: 'Cargar más campañas',
      financeLoadMorePayments: 'Cargar más pagos',
      // search/filter
      searchCeremony: 'Buscar ceremonia...',
      filterStatus: 'Filtrar por estado',
      allStatuses: 'Todos los estados',
      statusScheduled: 'Programada',
      statusCompleted: 'Completada',
      statusCancelled: 'Cancelada',
      // members panel
      membersPanelTitle: 'Miembros y Estadísticas',
      noRealtime: 'Sin tiempo real. Actualiza manualmente para recalcular.',
      closeMembersPanel: 'Cerrar panel de miembros',
      membersPanelDescription: 'Lista de miembros, ranking de asistencia e historial individual.',
      attendanceRateLabel: 'Asistencia',
      groupMembers: 'Miembros del grupo',
      noEnoughAttendance: 'Los indicadores aparecen cuando haya suficiente asistencia registrada.',
      noMembersFound: 'No se encontraron miembros para este grupo.',
      noPhoneRegistered: 'Sin teléfono registrado',
      loadingMemberDetails: 'Cargando detalles del miembro...',
      selectedMember: 'Miembro seleccionado',
      rateLabel: 'Tasa',
      consistencyLabel: 'Consistencia',
      presentLabel: 'Presentes',
      absencesLabel: 'Ausencias',
      recentCeremonies: 'Últimas ceremonias',
      selectMemberForDetails: 'Selecciona un miembro para ver detalles y tendencias individuales.',
      forgotCodeLink: '¿Olvidaste tu código?',
      forgotCodeTitle: 'Recuperar Código de Líder',
      forgotCodeSubtitle: 'Ingresa tu correo para recibir el código.',
      emailLabel: 'Correo Electrónico',
      emailPlaceholder: 'tu@correo.com',
      sendCode: 'Enviar Código',
      cancel: 'Cancelar',
      sendingCode: 'Enviando...',
      codeSent: '¡Código enviado a tu correo!',
      invalidEmail: 'Correo inválido.',
      forgotCodeError: 'Error al enviar código.',
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: {
      'pt': ['pt-BR', 'en'],
      'pt-br': ['pt-BR', 'en'],
      'pt-pt': ['pt-PT', 'en'],
      default: ['en'],
    },
    load: 'currentOnly',
    supportedLngs: ['pt-BR', 'pt-PT', 'en', 'es'],
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
